import styled from "styled-components";

export const AccordionContainer = styled.div`
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    width: 100%;
    padding-right: 20px;
  }
  .left-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    h4 {
      font-size: 18px;
      line-height: 150.5%;
      font-family: "latobold";
    }
  }
  .input-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    p {
      font-size: 13px;
      line-height: 16px;
    }
    input {
      background: #ffffff;
      border: 0.5px solid #cdcfd0;
      border-radius: 6px;
      height: 30px;
    }
  }
  .button-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    > button {
      :first-child,
      :nth-child(2) {
        font-size: 13px;
        line-height: 150.5%;
        text-decoration-line: underline;
        color: #4881cc;
        border: none;
        background-color: transparent;
      }
    }
  }
  .MuiCollapse-wrapper {
    margin-bottom: 10px;
  }
  .MuiAccordionSummary-root {
    background: #efefef;
    border: 0.5px solid #cdcfd0;
    border-radius: 6px;
    padding: 0 12px;
    min-height: 40px !important;
  }
  .MuiAccordionSummary-content {
    margin: 0;
  }
  .MuiAccordionSummary-expandIconWrapper {
    display: flex;
    align-items: center;
  }

  .Mui-expanded {
    min-height: 40px !important;
    margin: 0 !important;
  }
  .MuiAccordionSummary-root.Mui-expanded {
    margin-bottom: 15px !important;
  }
  .MuiAccordionDetails-root {
    padding: 0;
  }
`;

export const TableWrapper = styled.div`
  table,
  th,
  td {
    border: 1px solid #b9b9b9;
    border-collapse: collapse;
  }
  table {
    width: 100%;
    text-align: center;
    tr th {
      font-size: 18px;
      line-height: 22px;
      font-family: "latobold";
      color: var(--theme-text);
      font-weight: normal;
      background: #010101;
      padding: 5px;
      :first-child {
        width: 75px;
      }
      .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;
        button {
          background-color: transparent;
          border: none;
        }
      }
      .gap {
        gap: 15px;
      }
    }
    td {
      font-size: 12px;
      line-height: 100%;
      min-width: 90px;
      :first-child {
        font-size: 18px;
        line-height: 22px;
      }
    }
    .sec-header {
      th {
        font-family: "latomedium";
        background: #fff;
        color: #010101;
        padding: 9px 5px;
        .page-type {
          display: flex;
          justify-content: space-around;
          align-items: center;
        }
      }
    }
    tr td {
      button {
        background-color: transparent;
        border: none;
        padding: 5px;
      }
    }
  }
`;
